import script from "./CurrencyInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&setup=true&lang=ts"

import "./CurrencyInput.vue?vue&type=style&index=0&id=4f358a91&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f358a91"]])

export default __exports__